import './Subscriptions.scss';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getSubscriptionListService } from '../../../services/CmsService';
import { NoDataFound } from '../../../components/no-data-found';
import { SubscriptionItemPlaceholder } from '../../../components/skeleton-placeholder';
import PaymentModal from '../../../components/payment-element/PaymentModal';
import { useAuth } from '../../../contexts/AuthProvider';

const Subscription = () => {
    const history = useHistory();
    const { authed } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [subscriptionList, setSubscriptionList] = useState([]);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [subscriptionData, setSubscriptionData] = useState();

    const getSubscriptionList = async () => {
        setIsLoading(true);
        await getSubscriptionListService({
            userId: authed?.user?._id || null
        }, (res) => {
            // console.log("subscription list res==>", res.data);
            if (res.status === 200) {
                const { response_data } = res.data;
                setSubscriptionList(response_data);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
            setIsLoading(false);
        });
    };

    const handleSubscriptionItem = (data) => {
        setSubscriptionData(data);
        setShowPaymentModal(true);
    }
    const disabledActiveBtn = subscriptionList?.some(item => item.userActiveStatus === true);

    useEffect(() => {
        getSubscriptionList();
    }, []);

    return (
        <>

            <section className="inner-title-block inner-mrt-80">
                <div className="container-lg text-center">
                    <h1>Pricing Plans</h1>
                </div>
            </section>
            <section className="cmn-info-wrapper padd-top-70 padd-bottom-70">
                <div className="container-lg clearfix subscription-info">
                    {isLoading ? (
                        <SubscriptionItemPlaceholder number={"3"} />
                    ) : (
                        <>
                            {subscriptionList.length > 0 ? (
                                <div className="row justify-content-center">
                                    {subscriptionList.map((item) => {
                                        return (
                                            <div key={item._id} className="col-md-4 my-3">
                                                <div className={`subscription-item ${item.userActiveStatus ? "active border-success" : ""}`}>
                                                    {item?.userActiveStatus && (<div className='subscription-badge bg-success'>Active</div>)}
                                                    <div className="subscription-item-header">
                                                        <h4>{item?.productDetails?.name || "N/A"}</h4>
                                                        <p>{item?.productDetails?.description || "N/A"}</p>
                                                    </div>
                                                    <div className="subscription-item-body">
                                                        <div className="subscription-item-price">
                                                            <span className={`price ${item?.productDetails?.name === "Beginning" ? "text-decoration-line-through" : ""}`}>{item?.priceDetails?.currency} {item?.priceDetails?.unit_amount}</span>&nbsp;/&nbsp;<span className='month'>{item?.priceDetails?.recurring?.interval}</span>
                                                        </div>
                                                        {authed?.isAuth === true ? (
                                                            <button type='button' disabled={item?.productDetails?.name === "Beginning" || item?.userActiveStatus || disabledActiveBtn} onClick={() => handleSubscriptionItem(item)} className='btn btn-secondary-color btn-border-color subscription-btn'>{item?.productDetails?.name === "Beginning" ? "Beginning" : item.userActiveStatus ? "Subscribed" : "Subscribe Now"}</button>
                                                        ) : (
                                                            <button type='button' onClick={() => history.push('/signin')} className='btn btn-secondary-color btn-border-color subscription-btn'>Subscribe Now</button>
                                                        )}

                                                        <div dangerouslySetInnerHTML={{ __html: item?.subscriptionFeatures || "N/A" }}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <NoDataFound />
                            )}
                        </>
                    )}
                </div>
            </section>
            
            {authed?.isAuth === true && (
                <PaymentModal
                    subscriptionData={subscriptionData}
                    showPaymentModal={showPaymentModal}
                    setShowPaymentModal={setShowPaymentModal}
                    subscriptionFnc={() => getSubscriptionList()}
                />
            )}
        </>
    );
}

export default Subscription;
